export const GalleryImages = {
    interior: {
        commercial: [...Array(47)].map((_, index) => ({
            name: 'Commercial Interior',
            image:`https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fgallery%2Finterior%2Fcommercial%2F${index + 1}.jpg?alt=media&token=55f23437-2666-4681-8410-be17b76624be`

        })),
        
        residential: [...Array(45)].map((_, index) => ({
            name: 'Residential Interior',
            image: `https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fgallery%2Finterior%2Fresidential%2F${index + 1}.jpg?alt=media&token=ddb68ccb-87d5-422f-8c15-be7b0684729c` // Spaces are preserved in the path
        })),
    },
    architecture: {
        commercial: [...Array(32)].map((_, index) => ({
            name: 'Commercial Architecture',
            image:`https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fgallery%2Farchitecture%2Fcommercial%2F${index + 1}.jpg?alt=media&token=51aa023a-10ec-42bd-b3aa-224550da54bc` // Spaces are preserved in the path
        })),
        
        residential: [...Array(45)].map((_, index) => ({
            name: 'Residential Architecture',
            image: `https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fgallery%2Farchitecture%2Fresidential%2F${index + 1}.jpg?alt=media&token=42acdda3-6e74-4d6c-a899-0afe1dea73a9` // Spaces are preserved in the path
        }))
    }
};
